import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromSperre } from "@/components/calculators/lineMappers";
import { vindsperreCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/vindsperre")({
  component: VindsperrePage,
});

function VindsperrePage() {
  const [area, setArea] = useState<number | "">("");
  const [bredde, setBredde] = useState<number | "">(2.7);
  const [lengde, setLengde] = useState<number | "">(50);
  const [overlapp, setOverlapp] = useState<number | "">(10);

  const r = useMemo(() => {
    if (area === "" || bredde === "" || lengde === "") return null;
    return vindsperreCalc({
      area_m2: Number(area),
      rull_bredde_m: Number(bredde),
      rull_lengde_m: Number(lengde),
      overlapp_pct: overlapp === "" ? undefined : Number(overlapp),
    });
  }, [area, bredde, lengde, overlapp]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Vind- og dampsperre" subtitle="Beregn antall ruller og tape." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Antall ruller", value: `${fmt(r.ruller, 0)} stk`, strong: true },
              { label: "Tape",          value: `${fmt(r.tape_m, 0)} m` },
            ]}
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Vindsperre`} lines={linesFromSperre(r, 'Vindsperre/dampsperre')} defaultLaborHours={Math.max(0, Math.round((Number(area) * 0.15) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn areal og rulldimensjoner.</div>}
      >
        <Field label="Areal" unit="m²"><NumberInput value={area} onChange={setArea} /></Field>
        <Field label="Rull­bredde" unit="m"><NumberInput value={bredde} onChange={setBredde} /></Field>
        <Field label="Rull­lengde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="Overlapp" unit="%"><NumberInput value={overlapp} onChange={setOverlapp} /></Field>
      </CalcShell>
    </>
  );
}
